import { DeliveryAddress } from '../types/delivery-selection.type';

export const STORE_DELIVERY_ADDRESS: DeliveryAddress = {
  type: 'store',
  _id: 'STORE_ID',
  title: 'Bio Culture',
  address: '12 Rue Jean-Baptiste Huet',
  zipCode: '78350',
  city: 'Jouy-en-Josas',
  complement: '',
  comment: '',
};
